import { schema } from 'normalizr';
import { country } from './country';

export const company = new schema.Entity('companies', {
  country,
});

export const companies = new schema.Array(company);
